import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["blocks", "extra", "data"],
  _excluded2 = ["children", "className"];
import { cloneElement, forwardRef, isValidElement } from 'react';
import { Render, Provider, Container, useStore } from 'react-login-page';
import { Username } from "./control/Username.js";
import { Password } from "./control/Password.js";
import { Submit } from "./control/Submit.js";
import { Footer } from "./control/Footer.js";
import { Logo } from "./control/Logo.js";
import { Title } from "./control/Title.js";
import { Banner } from "./control/Banner.js";
import './index.css';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export * from 'react-login-page';
export * from "./control/Username.js";
export * from "./control/Password.js";
export * from "./control/Submit.js";
export * from "./control/Title.js";
export * from "./control/Banner.js";
export * from "./control/Logo.js";
export * from "./control/Footer.js";
var RenderLogin = () => {
  var _useStore = useStore(),
    {
      blocks = {},
      extra = {},
      data
    } = _useStore,
    label = _objectWithoutPropertiesLoose(_useStore, _excluded);
  var {
    fields,
    buttons
  } = data || {
    fields: []
  };
  return /*#__PURE__*/_jsxs(Render, {
    children: [/*#__PURE__*/_jsxs("main", {
      children: [/*#__PURE__*/_jsxs("header", {
        children: [blocks.logo, " ", blocks.title]
      }), fields.sort((a, b) => a.index - b.index).map((item, idx) => {
        var extraLabel = extra[item.name];
        if (!item.children && !extraLabel) return null;
        if (!item.children && extraLabel) return /*#__PURE__*/_jsx("div", {
          children: extraLabel
        }, idx);
        var labelElement = label["$" + item.name];
        return /*#__PURE__*/_jsxs("label", {
          className: "rlp-" + item.name,
          children: [labelElement && /*#__PURE__*/_jsx("span", {
            className: "login-page11-label",
            children: labelElement
          }), /*#__PURE__*/_jsxs("article", {
            children: [item.children, extraLabel && /*#__PURE__*/_jsx("div", {
              children: extraLabel
            })]
          })]
        }, item.name + idx);
      }), /*#__PURE__*/_jsx("section", {
        children: buttons.sort((a, b) => a.index - b.index).map((item, idx) => {
          var child = item.children;
          if (! /*#__PURE__*/isValidElement(child)) return null;
          return /*#__PURE__*/cloneElement(child, _extends({}, child.props, {
            key: item.name + idx
          }));
        })
      }), blocks.footer]
    }), blocks.banner]
  });
};
var LoginPage = /*#__PURE__*/forwardRef((props, ref) => {
  var {
      children,
      className
    } = props,
    divProps = _objectWithoutPropertiesLoose(props, _excluded2);
  return /*#__PURE__*/_jsxs(Provider, {
    children: [/*#__PURE__*/_jsx(Username, {
      label: "Username"
    }), /*#__PURE__*/_jsx(Password, {
      label: "Password"
    }), /*#__PURE__*/_jsx(Submit, {}), /*#__PURE__*/_jsx(Logo, {}), /*#__PURE__*/_jsx(Title, {}), /*#__PURE__*/_jsx(Banner, {}), /*#__PURE__*/_jsxs(Container, _extends({}, divProps, {
      ref: ref,
      className: "login-page11 " + (className || ''),
      children: [/*#__PURE__*/_jsx(RenderLogin, {}), children]
    }))]
  });
});
var Login = LoginPage;
Login.Username = Username;
Login.Password = Password;
Login.Submit = Submit;
Login.Footer = Footer;
Login.Logo = Logo;
Login.Title = Title;
Login.Banner = Banner;
Login.displayName = 'LoginPage';
export default Login;